// extracted by mini-css-extract-plugin
module.exports = {"container":"Checkbox_container__1nc0n","checkbox":"Checkbox_checkbox__3slF-","checked":"Checkbox_checked__1dzXW","description":"Checkbox_description__2a0Tx"};